import React, { FC, useState } from 'react';
import { Typography } from '@components/atoms/Typography';
import styles from './ContactBox.module.css';
import { useTranslation } from 'react-i18next';

export interface ContactItem {
    icon: string;
    label: string;
    value: string;
    type?: 'phone' | 'email';
}

export interface ContactBoxProps {
    contacts: ContactItem[];
}

export const ContactBox: FC<ContactBoxProps> = ({ contacts }) => {
    const { t } = useTranslation();
    const title = t('contact-box-component.contact');
    const showNumberText = t('space-detail-component.show-number');

    const [phoneVisible, setPhoneVisible] = useState(false);

    const handleShowPhone = () => {
        setPhoneVisible(true);
    };

    return (
        <div className={styles.container}>
            <Typography classes="mt-2 mb-3" fontSize="24" fontWeight="900">
                {title}
            </Typography>
            {contacts.map((contact, index) => (
                <div key={index}>
                    <div className={styles.contactItem}>
                        <div className={styles.leftSection}>
                            <i className={contact.icon} style={{ marginRight: '8px' }} />
                            <Typography color="muted">{contact.label}</Typography>
                        </div>
                        <div className={styles.rightSection}>
                            {contact.type === 'phone' && !phoneVisible ? (
                                <span
                                    onClick={handleShowPhone}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#007bff',
                                        textDecoration: 'underline'
                                    }}
                                >
                                    {showNumberText}
                                </span>
                            ) : (
                                contact.value
                            )}
                        </div>
                    </div>
                    {index < contacts.length - 1 && <div className={styles.separator} />}
                </div>
            ))}
        </div>
    );
};
